// extracted by mini-css-extract-plugin
export default {"item":"TopCountries_item__86fhZ","flag":"TopCountries_flag__Z7yYs","price":"TopCountries_price__Icjne"};